import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "orderBy",
})

export class OrderByPipe implements PipeTransform {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	transform(value: any[], property: string): any[] {
		if (!value || !property) {
			return value;
		}

		return value.sort((a, b) => {
			const aValue = a[property];
			const bValue = b[property];

			if (aValue < bValue) {
				return -1;
			} else if (aValue > bValue) {
				return 1;
			} else {
				return 0;
			}
		});
	}
}
